import { render, staticRenderFns } from "./SearchDropdown.vue?vue&type=template&id=b83f885a"
import script from "./SearchDropdown.vue?vue&type=script&lang=js"
export * from "./SearchDropdown.vue?vue&type=script&lang=js"
import style0 from "./SearchDropdown.vue?vue&type=style&index=0&id=b83f885a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports